module.exports = __webpack_public_path__ + "static/media/luftkvalitet_icon_lar-mer_hvit.90adba00.svg";